module.exports = __webpack_public_path__ + "img/recursos.4840c6a1.png";